import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { SaveCancelButtonConfig } from '@models/form/button';
import { FileUpload } from '@models/file';

@Component({
  template: `
    <div class="pager-content">
      <mat-dialog-content class="row justify-center align-items-centered">
        <app-page-turner [file]="file" (emitClose)="close()"></app-page-turner>
      </mat-dialog-content>
    </div>
  `,
  styleUrls: ['./page-turner-dialog.component.scss'],
})
export class PageTurnerDialogComponent implements OnInit {
  buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig({
    save: 'Send',
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public file: FileUpload,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) {}

  ngOnInit(): void {}

  public close(): void {
    this.dialogRef.close();
  }
}
